export const defaultCredentialData = {
    uuid: null,
    name: null,
    active: true,
    data: {},
};
